import useAxios from 'axios-hooks';
import { UrlsBack } from '../constants/urls';
import { Dispatch, useEffect } from 'react';
import { AxiosError } from 'axios';
import { BackendErrorContainer } from '../config/axiosMessageExtractor';
import { TIME_RESTRICTION_ENABLED } from '../constants/settings';

export const useTimeRestrictions = (setRequestErrorMessage: Dispatch<AxiosError<BackendErrorContainer, any>>) => {
  const [{ data, loading }, refech] = useAxios<boolean>(UrlsBack.BankingDays, { manual: true });

  function onError(reason: any) {
    setRequestErrorMessage(reason);
  }

  useEffect(() => {
    refech().catch(onError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [data || !TIME_RESTRICTION_ENABLED, loading];
};
